const NOTIFICATION_TYPES = {
  NEW_ARTIFACT_STUDIES: 'NewArtifactStudies',
  MAINTENANCE_DEVICE_COUNT: 'MaintenanceDeviceCount',
  PROGRAM_SUBSCRIPTION: 'ProgramSubscription',
  SHIPPING_LABEL_CREATED: 'ShippingLabelCreated',
  FACILITY_SETTING_UPDATED: 'FacilitySettingUpdated',
  REMINDER_CREATE_SHIPMENT: 'ReminderCreateShipment',
  PENDING_UPLOAD_FLAGGED_STUDIES: 'PendingUploadFlaggedStudies',
  REMINDER_DEVICE_RETURN_7_DAYS: 'ReminderDeviceReturn7Days',
  REMINDER_DEVICE_RETURN_21_DAYS: 'ReminderDeviceReturn21Days',
  REMINDER_DEVICE_RETURN_26_DAYS: 'ReminderDeviceReturn26Days',
  CREATE_LABEL_RMA_REPLACEMENT: 'CreateLabelRmaReplacement',
};

export { NOTIFICATION_TYPES };
